import paymentSystems from './constants/payment-systems';

// eslint-disable-next-line import/no-anonymous-default-export
export default (currentPaymentGateway) => {
    const gateway = Object.values(paymentSystems).find(gw => gw === currentPaymentGateway) || paymentSystems.UNKNOWN;
    return ([gateway]);
};
